import React, { useState, useContext } from "react";
import { Link, useLocation, Redirect } from "react-router-dom";
import { Collapse, Nav, NavItem, NavLink as BootstrapNavLink, Badge } from "reactstrap";
import Flex from "../../components/common/Flex";
import { toast } from "react-toastify";
import { uploadManager } from "../../helpers/UploadManager";
import {
  DashboardIcon,
  MasterIcon,
  CmsIcon,
  UsersManagementIcon,
  LiveIcon,
  TvodIcon,
  AvodIcon,
  SvodIcon,
  AnalyticsIcon,
  AffiliateIcon,
  SettingsIcon,
  MarkettingIcon,
  AiIcon,
  ProfileIcon,
  AiHubIcon,
  CommunityIcon,
  AdServerIcon,
  DemandsIcon,
  ReportsIcon,
  CampaignsIcon,
  AdsTextIcon,
  BackToHomeIcon,
  ActionIcon,
  UploadIcon,
  DistributionChannelsIcon,
  MonetizationIcon,
  DashboardAnalyticsIcon,
  AppOnBoardingIcon,
  StatusControlIcon,
  ReelHubPublisher,
  BookShopIcon
} from "./icons";

import {
  homeRoutes,
  dashboardRoutes,
  groupPortalRoutes,
  master,
  AnalyticsRoutes,
  userManagement,
  scheduleRoutes,
  tvod,
  avod,
  demands,
  campaign,
  demandReports,
  adsText,
  svod,
  otherReports,
  configSettings,
  // userConfigSettings,
  EcommerceAnalytics,
  marketing,
  FinanceRoute,
  affiliateRoutes,
  contentPartnerAvod,
  tokenReportRoutes,
  Ecommerce,
  newAnalyticsRoutes,
  aiAnalyticsRoutes,
  community,
  uploadContentRoute,
  distributionChannelsRoute,
  monetizationOptionsRoute,
  dashboardAnalytics,
  appOnBoarding,
  statusControl,
  ReelPublisherRoute,
  bookshopRoutes
} from "../../routes";
import AppContext from "../../context/Context";
import { isGroupPortalRole } from "../../components/GroupPortal/roles";
import { RotateLeft } from "@material-ui/icons";

const iconMap = {
  Dashboard: <DashboardIcon />,
  "Agentic AI Hub": <AiHubIcon />,
  Master: <MasterIcon />,
  CMS: <CmsIcon />,
  "User Management": <UsersManagementIcon />,
  "My Group": <UsersManagementIcon />,
  "Action": <ActionIcon />,
  Live: <LiveIcon />,
  TVOD: <TvodIcon />,
  AVOD: <AvodIcon />,
  SVOD: <SvodIcon />,
  Analytics: <AnalyticsIcon />,
  Affiliate: <AffiliateIcon />,
  Settings: <SettingsIcon />,
  Config: <SettingsIcon />,
  Marketing: <MarkettingIcon />,
  Profile: <ProfileIcon />,
  Community: <CommunityIcon />,
  "Ad Server": <AdServerIcon />,
  Demands: <DemandsIcon />,
  Reports: <ReportsIcon />,
  Campaigns: <CampaignsIcon />,
  "Ads Text": <AdsTextIcon />,
  "Back to Home": <BackToHomeIcon />,
  "Upload Content": <UploadIcon />,
  "Distribution Channels": <DistributionChannelsIcon />,
  "Monetization Options": <MonetizationIcon />,
  "Dashboard Analytics": <DashboardAnalyticsIcon />,
  "App OnBoarding": <AppOnBoardingIcon />,
  "Onboarding": <AppOnBoardingIcon />,
  "Status & Control": <StatusControlIcon />,
  "Publisher": <ReelHubPublisher />,
  "Shop": <BookShopIcon />,
  "Token Report": <ReportsIcon />
};

const DASHBOARD_TAB_ROUTES = ["/viewership", "/subscription", "/avod-performance"];

const SideBarMenuItem = ({ route, collapsed }) => {
  const publisherName = localStorage.getItem("user_name") || "Profile";
  const isPublisherProfile = route.name === publisherName;
  return (
    <Flex align="center" className="sidebar-menu-item">
      {(iconMap[route.name] || isPublisherProfile) && (
        <span className="sidebar-icon-wrapper">{isPublisherProfile ? <ProfileIcon /> : iconMap[route.name]}</span>
      )}
      {!collapsed && <span className="nav-link-text" aiAgent={route.aiAgent} aiAgentIgnoreFor={route.aiAgentIgnoreFor} aiAgentKeywords={route.aiAgentKeywords} style={{ fontSize: '0.85rem' }}>{route.name}</span>}
      {!collapsed && !!route.badge && (
        <Badge color={route.badge.color || "soft-success"} pill className="ml-2">
          {route.badge.text}
        </Badge>
      )}
    </Flex>
  );
};

const ChannelSelector = ({ channels }) => {
  if (!channels || channels.length <= 1 || channels === "[]") return null;

  return (
    <div className="px-3 py-2">
      <select
        id="sidebarCommonChannel"
        className="form-control channel-drop-down"
        onChange={(e) => {
          localStorage.setItem("currentChannel", e.target.value);
          setTimeout(() => {
            if (window.location.href !== "/") {
              window.location.href = "/";
            }
          }, 100);
        }}
        defaultValue={localStorage.getItem("currentChannel")}
      >
        {channels.map((item) => (
          <option value={item.channel_id} key={item.channel_id}>
            {item.channel_name}
          </option>
        ))}
      </select>
    </div>
  );
};

const getPublisherConfigInfo = (keyName) => {
  let response = false;
  if (
    localStorage.getItem("publisherConfig") &&
    typeof localStorage.getItem("publisherConfig") !== "undefined" &&
    localStorage.getItem("publisherConfig") !== "undefined"
  ) {
    var publisherConfig = JSON.parse(localStorage.getItem("publisherConfig"));
    if (publisherConfig) {
      let configInfo = publisherConfig.filter((i) => keyName == i.key_name);
      response = configInfo[0] && configInfo[0].key_value;
      return response;
    }
  }
  return response;
};

const SideBarMenu = ({ collapsed, onMenuItemClick = () => {} }) => {
  const [openedIndexes, setOpenedIndexes] = useState([]);
  const [manuallyToggledMenus, setManuallyToggledMenus] = useState(new Set());
  const [isNavigating, setIsNavigating] = useState(false);
  const { setShowBurgerMenu } = useContext(AppContext);
  const location = useLocation();

  React.useEffect(() => {
    if (collapsed) {
      setOpenedIndexes([]);
    }
  }, [collapsed]);
  
  React.useEffect(() => {
    setOpenedIndexes([]);
    setManuallyToggledMenus(new Set());
  }, []);
  
  const [prevPathname, setPrevPathname] = useState(location.pathname);
  
  React.useEffect(() => {
    if (prevPathname !== location.pathname) {
      setOpenedIndexes([]);
      setManuallyToggledMenus(new Set());
      
      setTimeout(() => {
        const findActiveMenus = (routes, parentPath = []) => {
          let activeMenuPaths = [];
          
          routes.forEach((route, index) => {
            if (route.children) {
              const indexPath = [...parentPath, index];
              const pathKey = indexPath.join("-");
              
              const isActive = isMenuActive(route);
              
              if (isActive) {
                activeMenuPaths.push(pathKey);
                activeMenuPaths = [...activeMenuPaths, ...findActiveMenus(route.children, indexPath)];
              }
            }
          });
          
          return activeMenuPaths;
        };
        
        const activeMenuPaths = findActiveMenus(menuRoutes);
        setOpenedIndexes(activeMenuPaths);
      }, 50);
    }
    
    setPrevPathname(location.pathname);
  }, [location.pathname]);
  const isMenuActive = (route) => {
    if (!route || !route.to) return false;
    if (route.name === "Affiliate") {
      if (location.pathname.startsWith("/affiliate") ||
        location.pathname.startsWith("/report/affiliate") ||
        location.pathname.startsWith("/creatives") ||
        location.pathname.startsWith("/network")) {
        return true;
      }
      return false;
    }
    if (route.to === '/' && DASHBOARD_TAB_ROUTES.includes(location.pathname)) return true;
    if (route.to === '/' && location.pathname === '/') return true;
    if (route.to === '/') return false;
    if (location.pathname === route.to) return true;
    
    const directMatch = location.pathname.startsWith(route.to);
    
    if (route.children) {
      const hasActiveChild = route.children.some(child => {
        if (child.to && location.pathname.startsWith(child.to)) {
          return true;
        }
        
        if (child.children) {
          return child.children.some(grandchild => 
            grandchild.to && location.pathname.startsWith(grandchild.to)
          );
        }
        
        return false;
      });
      
      if (hasActiveChild) return true;
    }
    
    return directMatch;
  };

    const handleLogout = async () => {
    setIsNavigating(true);
    const activeCount = uploadManager.getActiveCount();
    if (activeCount > 0) {
      const confirmLeave = window.confirm("You have active uploads in progress. If you log out, your active uploads will be cancelled and lost. Are you sure you want to proceed?");
      if (!confirmLeave) {
        setIsNavigating(false);
        return;
      }
      await uploadManager.abortAll();
    }
    
    Object.keys(localStorage).forEach((key) => {
      if (key !== "existingPublishers") {
        localStorage.removeItem(key);
      }
    });
       window.location.replace("/login");
  };


   const handleRevertToSuperadmin = async () => {
    setIsNavigating(true);    
    const activeCount = uploadManager.getActiveCount();
    if (activeCount > 0) {
      const confirmLeave = window.confirm("You have active uploads in progress. If you revert to superadmin, your active uploads will be cancelled and lost. Are you sure you want to proceed?");
      if (!confirmLeave) {
        setIsNavigating(false);
        return;
      }
      await uploadManager.abortAll();
    }

    let superadmin = JSON.parse(localStorage.getItem("superadmin"));
    const keysToRestore = [
      "role_id", "isRTL", "user_name", "channelConfig", "favouriteItems", 
      "publisherConfig", "bucketType", "isFluid", "currentChannel", "isTopNav", 
      "pub_id", "isDark", "isNavbarVerticalCollapsed", "user_email", "products"
    ];
    const keysToRemove = ["superadmin", "influencer_id", "merchant_id", "merchant_name"];

    keysToRestore.forEach(key => localStorage.setItem(key, superadmin[key]));
    keysToRemove.forEach(key => localStorage.removeItem(key));
    localStorage.setItem("shoppingCart", superadmin.shoppingCart);
    localStorage.setItem("add_server_admin", "false");
    
    toast.success(`Reverting to Superadmin`);
    window.location.replace("/");
  };

  if (isNavigating) {
    return null;
  }

  const toggleOpened = (e, index, parentPath = []) => {
    e.preventDefault();
    const indexPath = [...parentPath, index];
    const pathKey = indexPath.join("-");

    setManuallyToggledMenus(prev => {
      const newSet = new Set(prev);
      newSet.add(pathKey);
      return newSet;
    });

    setOpenedIndexes((prev) => {
      const isExactlyOpen = prev.includes(pathKey);
      if (isExactlyOpen) {
        return prev.filter((item) => !item.startsWith(pathKey));
      } else {
        const newIndexes = prev.filter((item) => {
          const parts = item.split('-');
          const itemParentPath = parts.slice(0, -1).join('-');
          const currentParentPath = parentPath.join('-');
          return itemParentPath !== currentParentPath;
        });
        return [...newIndexes, pathKey];
      }
    });
  };

  let jsonRoutes = [];
  let filteredRoutes = [];
  let filteredMenuRoutes = [];

  const handleSetNavbarCollapsed = () => {
    setShowBurgerMenu(false);
  };
  const role_id = localStorage.getItem("role_id");
  const pub_id = localStorage.getItem("pub_id");
  let storedTopLevelRoutes = [];

  try {
    const parsedRoutes = JSON.parse(localStorage.getItem("routes") || "[]");
    storedTopLevelRoutes = Array.isArray(parsedRoutes) ? parsedRoutes : [];
  } catch (error) {
    storedTopLevelRoutes = [];
  }

  const hasAnalyticsAccess = storedTopLevelRoutes.includes("Analytics");

  let publisherChannels = [];
  if (
    localStorage.getItem("channelConfig") &&
    typeof localStorage.getItem("channelConfig") !== "undefined" &&
    localStorage.getItem("channelConfig") !== "undefined" &&
    localStorage.getItem("channelConfig") !== "[]"
  ) {
    publisherChannels = JSON.parse(localStorage.getItem("channelConfig"));
  }

  if (publisherChannels && publisherChannels.length > 0) {
    localStorage.setItem(
      "currentChannel",
      localStorage.getItem("currentChannel")
        ? localStorage.getItem("currentChannel")
        : publisherChannels[0]?.channel_id
    );
  }

  const channelChange = (e) => {
    const selectedChannel = e.target.value;
    localStorage.setItem("currentChannel", selectedChannel);
    setTimeout(() => {
      if (window.location.href !== "/") {
        window.location.href = "/";
      }
    }, 100);
  };

  if (localStorage.getItem("routes") !== "undefined") {
    const storedRoutes = JSON.parse(localStorage.getItem("routes"));
    const flattenRoutes = (routes) => {
      let flattened = [];
      routes.forEach((route) => {
        if (route.name) {
          flattened.push(route);
        }
        if (route.children && Array.isArray(route.children)) {
          flattened = flattened.concat(flattenRoutes(route.children));
        }
      });
      return flattened;
    };
if (
  storedRoutes?.includes("Agentic AI Hub") &&
  getPublisherConfigInfo("ai_command_needed") === "True"
) {
  const aiRoute = aiAnalyticsRoutes();
  if (aiRoute && aiRoute.name) {
      const routeToPush = { 
        name: aiRoute.name, 
        to: aiRoute.to 
      };

      if (aiRoute.children && aiRoute.children.length > 0) {
        routeToPush.children = aiRoute.children;
      }

      jsonRoutes.push(routeToPush);
    }
  }

    if (storedRoutes?.includes("CMS")) {
      jsonRoutes.push(dashboardRoutes());
    }
    if (storedRoutes?.includes("Live")) {
      jsonRoutes.push(scheduleRoutes);
    }
    if (storedRoutes?.includes("Community")) {
      jsonRoutes.push(community());
    }
    if (storedRoutes?.includes("User Management")) {
      jsonRoutes.push(userManagement());
    }
    if (storedRoutes?.includes("Affiliate")) {
      jsonRoutes.push(affiliateRoutes);
    }
    if (storedRoutes?.includes("Settings")) {
      jsonRoutes.push(configSettings());
    }
    if (storedRoutes?.includes("Marketing")) {
      jsonRoutes.push(marketing());
    }
    if (storedRoutes?.includes("Analytics")) {
      jsonRoutes.push(otherReports());
    }
    if (getPublisherConfigInfo("svod_needed") === "True") {
      if (storedRoutes?.includes("SVOD")) {
        jsonRoutes.push(svod());
      }
    }
    if (getPublisherConfigInfo("avod_needed") === "True") {
      if (storedRoutes?.includes("AVOD")) {
        jsonRoutes.push(avod);
      }
    }
    if (jsonRoutes?.length > 0) {
      const allRoutes = flattenRoutes(jsonRoutes);

      if (storedRoutes && Array.isArray(storedRoutes)) {
        filteredRoutes = allRoutes.filter((route) =>
          storedRoutes.includes(route.name)
        );
      }
    }
  }
  const renderMenuItems = (routes, parentPath = [], collapsed) => {
 const nonProfileRoutes = routes.filter(route => 
    !route.isProfileSeparator && route.name !== localStorage.getItem("user_name")
  );
  const profileRoutes = routes.filter(route => 
    route.isProfileSeparator || route.name === localStorage.getItem("user_name")
  );

  if (!nonProfileRoutes || nonProfileRoutes.length === 0) {
    localStorage.setItem("hasNoMenuAccess", "true");
    return (
      <>
        <Redirect to="/contact-support" />
        {profileRoutes.map((route, index) => {
          const indexPath = [...parentPath, index];
          return createMenuItem(route, indexPath.join("-"));
        })}
      </>
    );
  }
  localStorage.removeItem("hasNoMenuAccess");
    return routes.map((route, index) => {
      const indexPath = [...parentPath, index];
      const pathKey = indexPath.join("-");
      const isOpen = openedIndexes.includes(pathKey);
      const isActive = isMenuActive(route);

      if (route.isProfileSeparator) {
        return <div key={pathKey} className="sidebar-profile-separator" aria-hidden="true" />;
      }

      if (!route.children || route.children.length === 0) {
        return (
          <NavItem key={pathKey}>
            {route.onClick ? (
              <Link
                className={`nav-link ${isActive ? 'active' : ''}`}
                to={route.to}
                aria-label={route.name}
                onClick={(e) => {
                  e.preventDefault();
                  route.onClick();
                  setShowBurgerMenu(false);
                  setManuallyToggledMenus(new Set());
                  onMenuItemClick();
                }}
              >
                <SideBarMenuItem route={route} collapsed={collapsed} />
              </Link>
            ) : (
              <Link
                className={`nav-link ${isActive ? 'active' : ''}`}
                to={route.to}
                aria-label={route.name}
                onClick={() => {
                  setShowBurgerMenu(false);
                  setManuallyToggledMenus(new Set());
                  onMenuItemClick();
                }}
              >
                <SideBarMenuItem route={route} collapsed={collapsed} />
              </Link>
            )}
          </NavItem>
        );
      }

      const wasManuallyToggled = manuallyToggledMenus.has(pathKey);
      const hasActiveChild = isActive && route.children && route.children.some(child => 
        child.to && location.pathname.startsWith(child.to));
        const shouldBeOpen = hasActiveChild && !wasManuallyToggled && !isOpen;

      return (
        <NavItem key={pathKey}>
          <BootstrapNavLink
            onClick={(e) => toggleOpened(e, index, parentPath)}
            className={`dropdown-indicator cursor-pointer ${isActive ? 'active' : ''}`}
            aria-expanded={isOpen}
            aria-label={route.name}
          >
            <SideBarMenuItem route={route} collapsed={collapsed} />
          </BootstrapNavLink>
          <Collapse isOpen={isOpen || shouldBeOpen}>
            <Nav className="nested-sidebar">
              {route.name === "Profile" &&
                publisherChannels &&
                publisherChannels.length > 1 && (
                  <ChannelSelector channels={publisherChannels} />
                )}
              {renderMenuItems(route.children, indexPath, collapsed)}
            </Nav>
          </Collapse>
        </NavItem>
      );
    });
  };
  const createMenuItem = (route, key) => {
    if (!route) return null;

    const pathKey = key.toString();
    const isOpen = openedIndexes.includes(pathKey);
    const isActive = isMenuActive(route);

    return (
      <NavItem key={key}>
        {!route.children ? (
          <Link
            className={`nav-link ${isActive ? 'active' : ''}`}
            to={route.to || '#'}
            onClick={() => {
              handleSetNavbarCollapsed();
              setManuallyToggledMenus(new Set());
              onMenuItemClick();
            }}
            title={collapsed ? route.name : ''}
          >
            <SideBarMenuItem route={route} collapsed={collapsed} />
          </Link>
        ) : (
          <>
            <BootstrapNavLink
              onClick={(e) => toggleOpened(e, key, [])}
              className={`dropdown-indicator cursor-pointer ${isActive ? 'active' : ''}`}
              aria-expanded={isOpen}
              title={collapsed ? route.name : ''}
            >
              <SideBarMenuItem route={route} collapsed={collapsed} />
            </BootstrapNavLink>
            <Collapse isOpen={isOpen}>
              <Nav className="nested-sidebar">{renderMenuItems(route.children, [key], collapsed)}</Nav>
            </Collapse>
          </>
        )}
      </NavItem>
    );
  };

  let menuRoutes = [];

  const isOnboardingDomain = [
    "next.dashboard.gizmott.com",
    "dev.console.gizmott.com",
  ].includes(window.location.hostname);

  if (role_id !== "15" || hasAnalyticsAccess) {
    menuRoutes.push({
      to: "/",
      name: "Dashboard",
      exact: true,
    });
  }
  
  if (getPublisherConfigInfo("ai_command_needed") === "True" && role_id !== "7") {
    menuRoutes.push({
      name: aiAnalyticsRoutes().name,
      to: aiAnalyticsRoutes().to,
      icon: aiAnalyticsRoutes().icon,
    });
  }

  const isOnboardingRequired = String(getPublisherConfigInfo("publisher_onboarding_required")) === "True";
  const isSuperAdmin = role_id === "7" || !!localStorage.getItem("superadmin");
  const isNormalPublisher = !["8", "13", "15", "17", "18", "19", "20", "21"].includes(role_id) && role_id !== "7";
  if ((isSuperAdmin || isNormalPublisher) && isOnboardingRequired) {
    menuRoutes.push({
      name: "Onboarding",
      to: "/publisher-onboarding",
      icon: "list",
      onClick: () => window.open(`${window.location.origin}/publisher-onboarding`, "_blank"),
    });
  }

  menuRoutes.push({
    name: master().name,
    to: master().to,
    children: master().children,
  });

  if (role_id === "7") {
    menuRoutes.push({
      name: AnalyticsRoutes().name,
      to: AnalyticsRoutes().to,
      children: AnalyticsRoutes().children,
    });
  }


  if (role_id !== "7") {
    menuRoutes.push({
      name: dashboardRoutes().name,
      to: dashboardRoutes().to,
      children: dashboardRoutes().children,
    });
  }

  if (role_id !== "8" && role_id !== "17" && role_id !== "7") {
    menuRoutes.push({
      name: userManagement().name,
      to: userManagement().to,
      children: userManagement().children,
    });
  }

  if (getPublisherConfigInfo("linear_needed") === "True") {
    menuRoutes.push({
      name: scheduleRoutes.name,
      to: scheduleRoutes.to,
      children: scheduleRoutes.children,
    });
  }

  if (role_id !== "7" && (pub_id !== '50034' || localStorage.getItem("superadmin"))) {
    menuRoutes.push({
      name: newAnalyticsRoutes.name,
      to: newAnalyticsRoutes.to,
      icon: newAnalyticsRoutes.icon,
      children: newAnalyticsRoutes.children,
    });
  }

  if (getPublisherConfigInfo("tvod_needed") === "True") {
    menuRoutes.push({
      name: tvod().name,
      to: tvod().to,
      children: tvod().children,
    });
  }

  if (getPublisherConfigInfo("avod_needed") === "True") {
    menuRoutes.push({
      name: avod.name,
      to: avod.to,
      children: avod.children,
    });
  }
  
  if (getPublisherConfigInfo("token_bundles_needed") === "True") {
    menuRoutes.push({
      name: tokenReportRoutes.name,
      to: tokenReportRoutes.to,
      icon: tokenReportRoutes.icon,
      children: tokenReportRoutes.children,
    });
  }
  // if (getPublisherConfigInfo("svod_needed") === "True") {
  //   menuRoutes.push({
  //     name: svod().name,
  //     to: svod().to,
  //     children: svod().children,
  //   });
  // }

  // if (role_id !== "7") {
  //   menuRoutes.push({
  //     name: otherReports().name,
  //     to: otherReports().to,
  //     children: otherReports().children,
  //   });
  // }

  if (getPublisherConfigInfo("ad_server_needed") === "True") {
    menuRoutes.push({
      name: demands.name,
      to: demands.to,
      children: localStorage.getItem("superadmin")
       ? 
       demands.children :demands.children.filter(
        item => item.name !== "Partners" && item.name !== "Demands"
      ),
    });

    menuRoutes.push({
      name: campaign.name,
      to: campaign.to,
      children: campaign.children,
    });

    menuRoutes.push({
      name: demandReports.name,
      to: demandReports.to,
      children: demandReports.children,
    });
  }

  if (role_id !== "7") {
    menuRoutes.push({
      name: affiliateRoutes.name,
      to: affiliateRoutes.to,
      children: affiliateRoutes.children,
    });
  }

  if (getPublisherConfigInfo("books_needed") === "True") {
    menuRoutes.push({
      name: bookshopRoutes.name,
      to: bookshopRoutes.to,
      children: bookshopRoutes.children,
    });
  }

  if (role_id !== "7" 
     && (localStorage.getItem("superadmin") || getPublisherConfigInfo("config_settings_needed") == "True")
  ) {
    menuRoutes.push({
      name: configSettings().name,
      to: configSettings().to,
      children: configSettings().children,
    });
  }

  // if (!localStorage.getItem("superadmin") && localStorage.getItem("pub_id") === "50167") {
  //   menuRoutes.push({
  //     name: userConfigSettings.name,
  //     to: userConfigSettings.to,
  //     children: userConfigSettings.children,
  //   });
  // }

  if (role_id !== "7") {
    menuRoutes.push({
      name: marketing().name,
      to: marketing().to,
      children: marketing().children,
    });
  }
  if (getPublisherConfigInfo("community_needed") == "True") {
    menuRoutes.push({
      name: community().name,
      to: community().to,
      children: community().children,
    });
  }

  if (
    getPublisherConfigInfo("ecommerce_needed") === "True" ||
    role_id === "12"
  ) {
    menuRoutes.push({
      name: Ecommerce().name,
      to: Ecommerce().to,
      children: Ecommerce().children,
    });

    menuRoutes.push({
      name: EcommerceAnalytics().name,
      to: EcommerceAnalytics().to,
      children: EcommerceAnalytics().children,
    });
  }

  if (role_id === "14") {
    menuRoutes.push({
      name: FinanceRoute().name,
      to: FinanceRoute().to,
      children: FinanceRoute().children,
    });
  }

  if (
    getPublisherConfigInfo("ad_server_needed") === "True" ||
    role_id === "7"
  ) {
    menuRoutes.push({
      name: "Ad Server",
      to: "/ad-server",
      onClick: () => localStorage.setItem("add_server_admin", "true"),
    });
  }

  if (role_id === "7") {
    menuRoutes.push({
      name: "User Management",
      to: "/user/role",
    });
  }
  if (role_id === "7") {
    menuRoutes.push({
      name: "Action",
      to: "/live/channel/restart",
    });
  }

  let mainMenuRoutes = [...menuRoutes];

  if (localStorage.getItem("routes") !== "undefined") {
    const storedRoutes = JSON.parse(localStorage.getItem("routes"));
    if (storedRoutes && Array.isArray(storedRoutes)) {
      const allowedTopLevelRoutes = new Set([
        "Dashboard",
        "Onboarding",
        ...storedRoutes,
      ]);

      filteredMenuRoutes = mainMenuRoutes.filter((route) => {
        if (!route || route.isProfileSeparator) return false;
        return allowedTopLevelRoutes.has(route.name);
      });
    }
  }

  if (role_id === "8" || role_id === "17") {
    menuRoutes = [];

    menuRoutes.push({
      name: homeRoutes.name,
      to: "/",
      children: homeRoutes.children,
    });

    menuRoutes.push({
      name: dashboardRoutes().name,
      to: dashboardRoutes().to,
      children: dashboardRoutes().children,
    });

    if (getPublisherConfigInfo("tvod_needed") === "True") {
      menuRoutes.push({
        name: tvod().name,
        to: tvod().to,
        children: tvod().children,
      });
    }

    if (getPublisherConfigInfo("avod_needed") === "True") {
      menuRoutes.push({
        name: contentPartnerAvod().name,
        to: contentPartnerAvod().to,
        children: contentPartnerAvod().children,
      });

      menuRoutes.push({
        name: tokenReportRoutes.name,
        to: tokenReportRoutes.to,
        icon: tokenReportRoutes.icon,
        children: tokenReportRoutes.children,
      });
    }

    if (getPublisherConfigInfo("svod_needed") === "True") {
      menuRoutes.push({
        name: svod().name,
        to: svod().to,
        children: svod().children,
      });
    }

    if (getPublisherConfigInfo("linear_needed") === "True") {
      menuRoutes.push({
        name: scheduleRoutes.name,
        to: scheduleRoutes.to,
        children: scheduleRoutes.children,
      });
    }

    menuRoutes.push({
      name: otherReports().name,
      to: otherReports().to,
      children: otherReports().children,
    });
  } else if (role_id === "18") {
    menuRoutes = [];
    menuRoutes.push({
      name: community().name,
      to: community().to,
      children: community().children,
    });
  }
  else if (role_id === "19") {
    menuRoutes = [];
    menuRoutes.push({
      name: ReelPublisherRoute().name,
      to: ReelPublisherRoute().to,
      children: ReelPublisherRoute().children,
    });
  }else if (role_id === "20") {
    menuRoutes = [];
    menuRoutes.push({
      name: uploadContentRoute().name,
      to: uploadContentRoute().to,

      children: uploadContentRoute().children,
    });
    menuRoutes.push({
      name: distributionChannelsRoute().name,
      to: distributionChannelsRoute().to,
      children: distributionChannelsRoute().children,
    });
    menuRoutes.push({ 
      name: monetizationOptionsRoute().name,
      to: monetizationOptionsRoute().to,
      children: monetizationOptionsRoute().children,
    });
  }else if (role_id === "21") {
    menuRoutes = [];
    menuRoutes.push({
      name: dashboardAnalytics().name,
      to: dashboardAnalytics().to,
      children: dashboardAnalytics().children,
    });
    menuRoutes.push({
      name: appOnBoarding().name,
      to: appOnBoarding().to,
      children: appOnBoarding().children,

    });
    menuRoutes.push({
      name: statusControl().name,
      to: statusControl().to,
      children: statusControl().children,
    });


  } else if (isGroupPortalRole(role_id)) {
    menuRoutes = [];
    menuRoutes.push({
      name: groupPortalRoutes().name,
      to: groupPortalRoutes().to,
      children: groupPortalRoutes().children,
    });
  } else if (role_id === "13") {
    menuRoutes = [];

    menuRoutes.push({
      name: FinanceRoute().name,
      to: FinanceRoute().to,
      children: FinanceRoute().children,
    });
  } else if (role_id === "15") {
    if (filteredMenuRoutes.length > 0) {
      menuRoutes = filteredMenuRoutes;
    } else {
      menuRoutes = [];
    }
  } else if (localStorage.getItem("add_server_admin") === "true") {
    menuRoutes = [];

    menuRoutes.push({
      name: demands.name,
      to: demands.to,
      children: localStorage.getItem("superadmin")
       ? 
      demands.children : demands.children.filter(
        item => item.name !== "Partners" && item.name !== "Demands"
      ),
    });

    menuRoutes.push({
      name: demandReports.name,
      to: demandReports.to,
      children: demandReports.children,
    });

    menuRoutes.push({
      name: campaign.name,
      to: campaign.to,
      children: campaign.children,
    });

    menuRoutes.push({
      name: adsText.name,
      to: adsText.to,
      children: adsText.children,
    });

    menuRoutes.push({
      name: "Back to Home",
      to: "/",
      onClick: () => {
        localStorage.setItem("add_server_admin", "false");
        window.location.href = "/";
      },
    });
  }

  menuRoutes.push({
    isProfileSeparator: true
  });

  const publisherName = localStorage.getItem("user_name") || "Profile";
  const accountListStorageKey = `availableAccounts:${String(localStorage.getItem("user_email") || "").toLowerCase()}`;
  let hasAvailableAccounts = false;

  try {
    const availableAccounts = JSON.parse(sessionStorage.getItem(accountListStorageKey) || "[]");
    hasAvailableAccounts = Array.isArray(availableAccounts) && availableAccounts.length > 0;
  } catch (error) {
    hasAvailableAccounts = false;
  }
  
  menuRoutes.push({
    name: publisherName,
    children: [
      {
        name: "Reset Password",
        to: "/password/reset",
        onClick: () => {
          setIsNavigating(true);
          window.location.href = "/password/reset";
        },
      },

      ...((role_id != 7 && !isGroupPortalRole(role_id)) ? [{
        name: "2-Step Verification",
        to: "/mfa-settings",
      }] : []),

      ...(role_id != 7 && role_id != 8 && role_id != 17 && !isGroupPortalRole(role_id) && getPublisherConfigInfo("data_usage_report_needed") === "True"
        ? [
          {
            name: "Data Usage and Limits",
            to: "/usage/limits",
            onClick: () => {
              setIsNavigating(true);
              window.location.href = "/usage/limits";
            },
          },
        ]
        : []),

      ...(hasAvailableAccounts ? [{
        name: "Switch Account",
        to: "/switch-account",
        onClick: () => {
          setIsNavigating(true);
          window.location.href = "/switch-account";
        },
      }] : []),

      ...(localStorage.getItem("superadmin")
        ? [
          {
            name: "Revert to Superadmin",
            to: "#",
            onClick: handleRevertToSuperadmin,
          },
        ]
        : []),
      {
        name: "Logout",
        to: "/login",
        onClick: handleLogout
      },
    ],
  });

  return renderMenuItems(menuRoutes);
};

export default SideBarMenu;